import { render, staticRenderFns } from "./StudentNoticeItem.vue?vue&type=template&id=3b17b599"
import script from "./StudentNoticeItem.vue?vue&type=script&lang=js"
export * from "./StudentNoticeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports